import { i as c, r as V, a as F, b as O, k as U, l as K, m as ee, h as a, H as P, g as te, e as ie, F as ne } from "./index-6e735f92.js";
import { n as j, N as se } from "./index.es-4615d47c-9156501b.js";
import { L as oe } from "./constants-3d8016e3-3c080f00.js";
import { i as re, a as ae, c as le, b as de, f as ce } from "./feedbackSync-d943ffc7-d1e98ba0.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
var J;
(function(i) {
  i.Error = "error", i.Warning = "warning", i.Info = "info", i.Success = "success";
})(J || (J = {}));
var z;
(function(i) {
  i.Component = "component", i.Api = "api", i.Auth = "auth";
})(z || (z = {}));
var Y;
(function(i) {
  i.endtime_not_in_future = "endtime_not_in_future", i.no_booking_info = "no_booking_info", i.no_timeslot_selected = "no_timeslot_selected", i.no_timezone_selected = "no_timezone_selected", i.no_booking_id = "no_booking_id", i.no_salt = "no_salt", i.invalid_start_time = "invalid_start_time", i.invalid_end_time = "invalid_end_time", i.invalid_timezone = "invalid_timezone", i.no_config_id = "no_config_id";
})(Y || (Y = {}));
class he {
  constructor() {
    this.component = (e) => {
      const t = z.Component, s = `${e} Error`;
      return {
        endtime_not_in_future: (n = '"endtime" can not be in the future') => ({
          title: s,
          message: n,
          category: t
        }),
        no_booking_info: (n = "No booking info provided") => ({
          title: s,
          message: n,
          category: t
        }),
        no_timeslot_selected: (n = "No timeslot selected") => ({
          title: s,
          message: n,
          category: t
        }),
        no_timezone_selected: (n = "No timezone selected") => ({
          title: s,
          message: n,
          category: t
        }),
        no_booking_id: (n = "No booking id provided") => ({
          title: s,
          message: n,
          category: t
        }),
        no_salt: (n = "No salt provided") => ({
          title: s,
          message: n,
          category: t
        }),
        invalid_start_time: (n = "Invalid start time") => ({
          title: s,
          message: n,
          category: t
        }),
        invalid_end_time: (n = "Invalid end time") => ({
          title: s,
          message: n,
          category: t
        }),
        invalid_timezone: (n = "Invalid timezone") => ({
          title: s,
          message: n,
          category: t
        }),
        no_config_id: (n = "No configuration id provided") => ({
          title: s,
          message: n,
          category: t
        })
      };
    }, this.api = (e) => {
      const t = z.Api, s = `${e} Error`;
      return {
        invalid_session: (n) => ({
          title: s,
          message: n,
          category: t
        }),
        general_error: (n) => ({
          title: s,
          message: n,
          category: t
        }),
        internal_error: (n) => ({
          title: s,
          message: n,
          category: t
        }),
        invalid_request_error: (n) => ({
          title: s,
          message: n,
          category: t
        }),
        timeslot_not_available: (n) => ({
          title: s,
          message: n,
          category: t
        }),
        provider_error: (n) => ({
          title: s,
          message: n,
          category: t
        }),
        not_found_error: (n) => ({
          title: s,
          message: n,
          category: t
        })
      };
    };
  }
}
class ge {
  constructor({ schedulerAPIURL: e, schedulerStore: t, sessionId: s, configId: n, slug: r, clientId: o }) {
    this.errors = new he(), this.schedulerStore = t, this.schedulerAPIURL = e, this.sessionId = s, this.configId = n, this.slug = r, this.clientId = o;
  }
  getHeaders() {
    return this.sessionId ? {
      Authorization: `Bearer ${this.sessionId}`
    } : {};
  }
  async makeAPIRequest(e, t, s, n = {}) {
    try {
      const r = new URL(this.schedulerAPIURL), o = "1.4.5";
      return r.pathname = e, await (await fetch(decodeURIComponent(r.toString()), {
        method: t,
        headers: {
          "Content-Type": "application/json",
          Origin: window.location.origin,
          "X-Source": "nylas-scheduling",
          "X-Nylas-Web-Elements-Version": o,
          ...n
        },
        body: s
      })).json();
    } catch (r) {
      return {
        error: {
          message: r.message,
          title: "API request failed",
          type: "api"
        }
      };
    }
  }
  getErrorMessage(e) {
    var s, n, r, o;
    let t = (e == null ? void 0 : e.message) || (e == null ? void 0 : e.title) || "Something went wrong";
    return (e == null ? void 0 : e.type) === "provider_error" && (t = ((n = (s = e == null ? void 0 : e.provider_error) == null ? void 0 : s.error) == null ? void 0 : n.message) || ((o = (r = e == null ? void 0 : e.provider_error) == null ? void 0 : r.error) == null ? void 0 : o.title) || "Something went wrong"), t;
  }
  setConfigId(e) {
    this.configId = e;
  }
  selectDate(e) {
    this.schedulerStore.set("selectedDate", e), this.schedulerStore.set("selectedTimeslot", null);
  }
  selectTime(e) {
    this.schedulerStore.set("selectedTimeslot", e);
  }
  selectTimezone(e) {
    this.schedulerStore.set("selectedTimezone", e);
  }
  selectLanguage(e) {
    this.schedulerStore.set("selectedLanguage", e), c.changeLanguage(e);
  }
  async toggleAdditionalData(e) {
    e || await this.refetchAvailability(), this.schedulerStore.set("showBookingForm", e);
  }
  setParticipantName(e) {
    const { bookingInfo: t } = this.schedulerStore.state;
    this.schedulerStore.set("bookingInfo", {
      ...t,
      primaryParticipant: {
        ...t == null ? void 0 : t.primaryParticipant,
        name: e
      }
    });
  }
  setParticipantEmail(e) {
    const { bookingInfo: t } = this.schedulerStore.state;
    this.schedulerStore.set("bookingInfo", {
      ...t,
      primaryParticipant: {
        ...t == null ? void 0 : t.primaryParticipant,
        email: e
      }
    });
  }
  async refetchAvailability() {
    const e = /* @__PURE__ */ new Date(), t = new Date(e.getFullYear(), e.getMonth(), 1).getTime() / 1e3, s = t < e.getTime() / 1e3 ? Math.floor(e.getTime() / 1e3) : t, n = new Date(e.getFullYear(), e.getMonth() + 1, 1).getTime() / 1e3;
    return await this.getAvailability(s, n);
  }
  async resetStoreStateAndFetchAvailability() {
    const e = /* @__PURE__ */ new Date(), t = await this.refetchAvailability(), s = this.schedulerStore.get("availability").find((r) => new Date(r.start_time) > /* @__PURE__ */ new Date());
    let n = e;
    return s && (n = s.start_time), this.schedulerStore.set("selectedDate", n), this.schedulerStore.set("eventInfo", null), this.schedulerStore.set("showBookingForm", !1), this.schedulerStore.set("selectedTimeslot", null), t;
  }
  async setReschedule(e) {
    this.schedulerStore.set("isLoading", !0);
    const t = this.schedulerStore.state.eventInfo;
    return t && this.schedulerStore.set("reschedulingEventInfo", t), this.schedulerStore.set("rescheduleBookingId", e), await this.getUISettings(), await this.resetStoreStateAndFetchAvailability().finally(() => {
      this.schedulerStore.set("isLoading", !1);
    });
  }
  async setCancel(e) {
    this.schedulerStore.set("cancelBookingId", e);
  }
  async setReject(e) {
    this.schedulerStore.set("rejectBookingId", e);
  }
  async resetCancel() {
    const e = await this.resetStoreStateAndFetchAvailability();
    return this.schedulerStore.set("cancelBookingId", ""), this.schedulerStore.set("rejectBookingId", ""), this.schedulerStore.set("cancelledEventInfo", null), e;
  }
  async goBack() {
    this.schedulerStore.set("cancelBookingId", "");
  }
  async resetConfirm() {
    const e = await this.resetStoreStateAndFetchAvailability();
    return this.schedulerStore.set("organizerConfirmationBookingId", ""), this.schedulerStore.set("confirmedEventInfo", void 0), e;
  }
  async bookTimeslot(e) {
    var x, w, L;
    this.schedulerStore.set("isLoading", !0);
    const { selectedTimeslot: t, selectedTimezone: s, bookingInfo: n, selectedLanguage: r } = this.schedulerStore.state;
    if (!e && !n)
      return { error: this.errors.component(c.t("createBookingErrorTitle")).no_booking_info() };
    const o = (e == null ? void 0 : e.timeslot) || t;
    if (!o)
      return { error: this.errors.component(c.t("createBookingErrorTitle")).no_timeslot_selected() };
    const l = e && (e != null && e.timezone) ? e == null ? void 0 : e.timezone : s, d = r || "en-US";
    if (!l)
      return { error: this.errors.component(c.t("createBookingErrorTitle")).no_timezone_selected() };
    const f = [...this.schedulerStore.get("availabilityOrderEmails")];
    let h = "";
    const u = (o == null ? void 0 : o.emails) || [], g = {};
    Object.entries((n == null ? void 0 : n.additionalFields) || {}).forEach(([y, B]) => {
      g[y] = B.value;
    });
    const p = e ? e == null ? void 0 : e.primaryParticipant : n == null ? void 0 : n.primaryParticipant, b = e ? (e == null ? void 0 : e.guests) || [] : (n == null ? void 0 : n.guests) || [], S = e ? e == null ? void 0 : e.additionalFields : g, m = this.getHeaders(), I = `/v3/scheduling/bookings${!this.sessionId && this.configId ? `?configuration_id=${this.configId}` : !this.sessionId && this.slug && this.clientId ? `?slug=${this.slug}&client_id=${this.clientId}` : ""}`;
    if (f.length === 0) {
      const y = await this.makeAPIRequest(decodeURIComponent(I), "POST", JSON.stringify({
        additional_fields: S,
        additional_guests: b,
        guest: { ...p },
        start_time: o.start_time.getTime() / 1e3,
        end_time: o.end_time.getTime() / 1e3,
        timezone: l,
        event_id: (o == null ? void 0 : o.event_id) || void 0,
        master_id: (o == null ? void 0 : o.master_id) || void 0,
        calendar_id: (o == null ? void 0 : o.calendar_id) || void 0,
        email_language: this.getTwoLetterLanguageCode(d)
      }), m);
      return this.schedulerStore.set("isLoading", !1), "data" in y ? (this.schedulerStore.set("eventInfo", y.data), y) : { error: y.error };
    }
    for (; f.length > 0; ) {
      if (h = f.shift(), !u.includes(h))
        continue;
      const y = await this.makeAPIRequest(decodeURIComponent(I), "POST", JSON.stringify({
        participants: h ? [{ email: h }] : void 0,
        additional_fields: S,
        additional_guests: b,
        guest: { ...p },
        start_time: o.start_time.getTime() / 1e3,
        end_time: o.end_time.getTime() / 1e3,
        timezone: l,
        email_language: this.getTwoLetterLanguageCode(d)
      }), m);
      if ("data" in y)
        return this.schedulerStore.set("isLoading", !1), this.schedulerStore.set("eventInfo", y == null ? void 0 : y.data), y;
      if ((w = (x = y.error) == null ? void 0 : x.message) != null && w.startsWith("The selected timeslot is unavailable"))
        continue;
      {
        this.schedulerStore.set("isLoading", !1);
        const B = (L = y.error) == null ? void 0 : L.type;
        let D = y.error;
        if (B && B in this.errors.api(c.t("createBookingErrorTitle"))) {
          const M = this.getErrorMessage(D);
          D = this.errors.api(c.t("createBookingErrorTitle"))[B](M);
        }
        return { error: D };
      }
    }
    return this.schedulerStore.set("isLoading", !1), {
      error: this.errors.api(c.t("createBookingErrorTitle")).timeslot_not_available("The selected timeslot is unavailable")
    };
  }
  async getUISettings() {
    var o;
    this.schedulerStore.set("isLoading", !0);
    const e = this.schedulerStore.get("rescheduleBookingId"), t = this.getHeaders();
    let s = !this.sessionId && this.configId ? `?configuration_id=${this.configId}` : !this.sessionId && this.slug && this.clientId ? `?slug=${this.slug}&client_id=${this.clientId}` : "";
    e && s ? s += `&booking_id=${e}` : e && (s += `?booking_id=${e}`);
    const n = `/v3/scheduling/ui-settings${s}`, r = await this.makeAPIRequest(n, "GET", void 0, t);
    if ("error" in r) {
      this.schedulerStore.set("isLoading", !1);
      const l = (o = r.error) == null ? void 0 : o.type;
      let d = r.error;
      return l && l in this.errors.api(c.t("getUISettingErrorTitle")) && (d = this.errors.api(c.t("getUISettingErrorTitle"))[l]((d == null ? void 0 : d.message) || (d == null ? void 0 : d.title) || "Something went wrong")), { error: d };
    }
    return "data" in r && this.schedulerStore.set("configSettings", r.data), this.schedulerStore.set("isLoading", !1), r;
  }
  getTwoLetterLanguageCode(e) {
    return e.split("-")[0];
  }
  getStartTimeWithMinBookingNotice(e) {
    var r;
    const t = (r = this.schedulerStore.get("configSettings")) == null ? void 0 : r.scheduler, s = t == null ? void 0 : t.min_booking_notice;
    if (!s)
      return e;
    const n = (/* @__PURE__ */ new Date()).getTime();
    return e < (n + s * 60 * 1e3) / 1e3 ? Math.floor((n + s * 60 * 1e3) / 1e3) : e;
  }
  getEndTimeForAvailableDaysInFuture(e) {
    var o, l;
    const t = /* @__PURE__ */ new Date(), s = (l = (o = this.schedulerStore.get("configSettings")) == null ? void 0 : o.scheduler) == null ? void 0 : l.available_days_in_future, n = Math.floor(K(t, s).getTime() / 1e3);
    return Math.min(n, e);
  }
  async getAvailability(e = 0, t = 0) {
    var g, p, b, S;
    this.schedulerStore.set("isLoading", !0);
    const s = new URLSearchParams(), n = /* @__PURE__ */ new Date(), r = n.getTime();
    if (t && t < r / 1e3)
      return this.schedulerStore.set("isLoading", !1), { error: this.errors.component(c.t("getAvailabilityErrorTitle")).endtime_not_in_future() };
    if (!e) {
      const m = new Date(n.getFullYear(), n.getMonth(), 1);
      e = Math.floor(m.getTime() / 1e3);
    }
    if (!t) {
      const m = new Date(n.getFullYear(), n.getMonth() + 1, 0);
      t = Math.floor(m.getTime() / 1e3);
    }
    t = this.getEndTimeForAvailableDaysInFuture(t);
    const o = this.getStartTimeWithMinBookingNotice(e);
    e = o, t = o > t ? o + 1 : t, s.append("start_time", encodeURIComponent(e.toString())), s.append("end_time", encodeURIComponent(t.toString())), this.configId && !this.sessionId ? s.append("configuration_id", encodeURIComponent(this.configId)) : this.slug && this.clientId && !this.sessionId && (s.append("slug", encodeURIComponent(this.slug)), s.append("client_id", encodeURIComponent(this.clientId)));
    const l = this.schedulerStore.get("rescheduleBookingId");
    l && s.append("booking_id", encodeURIComponent(l));
    const d = s.toString(), f = `/v3/scheduling/availability${d ? `?${d}` : ""}`, h = this.getHeaders(), u = await this.makeAPIRequest(decodeURIComponent(f), "GET", void 0, h);
    if ("error" in u) {
      this.schedulerStore.set("availability", []), this.schedulerStore.set("isLoading", !1);
      const m = (g = u.error) == null ? void 0 : g.type;
      let k = u.error;
      if (m && m in this.errors.api(c.t("getAvailabilityErrorTitle"))) {
        const I = this.getErrorMessage(k);
        k = this.errors.api(c.t("getAvailabilityErrorTitle"))[m](I);
      }
      return { error: k };
    }
    if ("data" in u) {
      const I = (((b = (p = u.data) == null ? void 0 : p.time_slots) == null ? void 0 : b.map((w) => ({
        ...w,
        start_time: new Date(w.start_time * 1e3),
        end_time: new Date(w.end_time * 1e3)
      }))) || []).filter((w) => w.start_time.getTime() > r).sort((w, L) => w.start_time.getTime() - L.start_time.getTime());
      this.schedulerStore.set("availability", I);
      const x = ((S = u.data) == null ? void 0 : S.order) || [];
      this.schedulerStore.set("availabilityOrderEmails", x);
    }
    return this.schedulerStore.set("isLoading", !1), u;
  }
  async cancelBooking(e, t) {
    var l;
    if (this.schedulerStore.set("isLoading", !0), !e)
      return { error: this.errors.component(c.t("cancelBookingErrorTitle")).no_booking_id() };
    const s = !this.sessionId && this.configId ? `?configuration_id=${this.configId}` : !this.sessionId && this.slug && this.clientId ? `?slug=${this.slug}&client_id=${this.clientId}` : "", n = `/v3/scheduling/bookings/${e}${s}`, r = this.getHeaders(), o = await this.makeAPIRequest(decodeURIComponent(n), "DELETE", JSON.stringify({
      action: "cancel",
      cancellation_reason: t
    }), r);
    if ("error" in o) {
      this.schedulerStore.set("isLoading", !1);
      const d = (l = o.error) == null ? void 0 : l.type;
      let f = o.error;
      if (d && d in this.errors.api(c.t("cancelBookingErrorTitle"))) {
        const h = this.getErrorMessage(f);
        f = this.errors.api(c.t("cancelBookingErrorTitle"))[d](h);
      }
      return { error: f };
    }
    return this.schedulerStore.set("cancelledEventInfo", {
      booking_id: e
    }), this.schedulerStore.set("rescheduleBookingId", ""), this.schedulerStore.set("isLoading", !1), o;
  }
  async rescheduleBooking(e, t) {
    var R;
    if (this.schedulerStore.set("isLoading", !0), !e)
      return { error: this.errors.component(c.t("rescheduleBookingErrorTitle")).no_booking_id() };
    const s = this.errors.api(c.t("rescheduleBookingErrorTitle")), n = this.errors.component(c.t("rescheduleBookingErrorTitle")), { bookingInfo: r, selectedTimeslot: o, selectedTimezone: l, selectedLanguage: d } = this.schedulerStore.state, { startTime: f, endTime: h, timezone: u } = t, g = f || (o == null ? void 0 : o.start_time);
    if (!g)
      return { error: n.invalid_start_time('Please pass "startTime" in data or set "selectedTimeslot" in the defaultSchedulerState.') };
    const p = h || (o == null ? void 0 : o.end_time);
    if (!p)
      return { error: n.invalid_end_time('Please pass "endTime" in data or set "selectedTimeslot" in the defaultSchedulerState.') };
    const b = this.schedulerStore.get("availabilityOrderEmails");
    let S = "";
    if (b.length > 0) {
      const v = (o == null ? void 0 : o.emails) || [];
      for (let E = 0; E < b.length; E++)
        if (v.includes(b[E])) {
          S = b[E];
          break;
        }
    }
    const m = u || l;
    if (!m)
      return { error: n.invalid_timezone('Please pass "timezone" in data or set "selectedTimezone" in the defaultSchedulerState.') };
    const k = (o == null ? void 0 : o.event_id) || void 0, I = (o == null ? void 0 : o.master_id) || void 0, x = (o == null ? void 0 : o.calendar_id) || void 0, w = {};
    Object.entries((r == null ? void 0 : r.additionalFields) || {}).forEach(([v, E]) => {
      w[v] = E.value;
    });
    const L = t ? t == null ? void 0 : t.primaryParticipant : r == null ? void 0 : r.primaryParticipant, y = t ? (t == null ? void 0 : t.guests) || [] : (r == null ? void 0 : r.guests) || [], B = t ? t == null ? void 0 : t.additionalFields : w, D = !this.sessionId && this.configId ? `?configuration_id=${this.configId}` : !this.sessionId && this.slug && this.clientId ? `?slug=${this.slug}&client_id=${this.clientId}` : "", M = `/v3/scheduling/bookings/${e}${D}`, _ = this.getHeaders(), C = await this.makeAPIRequest(decodeURIComponent(M), "PATCH", JSON.stringify({
      start_time: g.getTime() / 1e3,
      end_time: p.getTime() / 1e3,
      timezone: m,
      additional_fields: B,
      guest: { ...L },
      additional_guests: y,
      participants: S ? [{ email: S }] : void 0,
      email_language: this.getTwoLetterLanguageCode(d),
      event_id: k,
      master_id: I,
      calendar_id: x
    }), _);
    if ("error" in C) {
      this.schedulerStore.set("isLoading", !1);
      const v = (R = C.error) == null ? void 0 : R.type;
      let E = C.error;
      if (v && v in s) {
        const H = this.getErrorMessage(E);
        E = s[v](H);
      }
      return { error: E };
    }
    const N = this.schedulerStore.get("reschedulingEventInfo");
    if ("data" in C)
      this.schedulerStore.set("eventInfo", C == null ? void 0 : C.data);
    else if (N)
      this.schedulerStore.set("eventInfo", N);
    else {
      const v = {
        booking_id: e
      };
      this.schedulerStore.set("eventInfo", v);
    }
    return this.schedulerStore.set("isLoading", !1), C;
  }
  async updateBooking(e) {
    var u;
    this.schedulerStore.set("isLoading", !0);
    const { bookingId: t, status: s, reason: n } = e, r = this.schedulerStore.get("organizerConfirmationSalt"), o = s === "confirmed" ? c.t("confirmBookingErrorTitle") : c.t("rejectBookingErrorTitle");
    if (!t)
      return { error: this.errors.component(o).no_booking_id() };
    if (!r)
      return { error: this.errors.component(o).no_salt() };
    const l = !this.sessionId && this.configId ? `?configuration_id=${this.configId}` : !this.sessionId && this.slug && this.clientId ? `?slug=${this.slug}&client_id=${this.clientId}` : "", d = `/v3/scheduling/bookings/${t}${l}`, f = this.getHeaders(), h = await this.makeAPIRequest(decodeURIComponent(d), "PUT", JSON.stringify({
      status: s,
      cancellation_reason: n,
      salt: r
    }), f);
    if ("error" in h) {
      this.schedulerStore.set("isLoading", !1);
      const g = (u = h.error) == null ? void 0 : u.type;
      let p = h.error;
      if (g && g in this.errors.api(o)) {
        const b = this.getErrorMessage(p);
        p = this.errors.api(o)[g](b);
      }
      return { error: p };
    }
    return "data" in h && s === "confirmed" ? this.schedulerStore.set("confirmedEventInfo", h == null ? void 0 : h.data) : "request_id" in h && s === "cancelled" && this.schedulerStore.set("cancelledEventInfo", {
      booking_id: t
    }), this.schedulerStore.set("organizerConfirmationBookingId", ""), this.schedulerStore.set("isLoading", !1), h;
  }
  async validateGroupEventTimeslot(e) {
    var o, l;
    this.schedulerStore.set("isLoading", !0);
    const t = (o = this.schedulerStore.get("configSettings")) == null ? void 0 : o.configuration_id;
    if (!t)
      return { error: this.errors.component(c.t("validateTimeslotErrorTitle")).no_config_id() };
    const s = this.getHeaders(), n = `/v3/scheduling/configurations/${t}/group-events/validate-timeslot`, r = await this.makeAPIRequest(decodeURIComponent(n), "POST", JSON.stringify({
      ...e,
      start_time: e.start_time.getTime() / 1e3,
      end_time: e.end_time.getTime() / 1e3
    }), s);
    if ("error" in r) {
      this.schedulerStore.set("isLoading", !1);
      const d = (l = r.error) == null ? void 0 : l.type;
      let f = r.error;
      if (d && d in this.errors.api(c.t("validateTimeslotErrorTitle"))) {
        const h = this.getErrorMessage(f);
        f = this.errors.api(c.t("validateTimeslotErrorTitle"))[d](h);
      }
      return this.refetchAvailability(), { error: f };
    }
    return this.schedulerStore.set("selectedTimeslot", e), this.schedulerStore.set("showBookingForm", !0), this.schedulerStore.set("isLoading", !1), r;
  }
}
class ue {
  constructor({ schedulerAPIURL: e, nylasSchedulerStore: t, sessionId: s, configId: n, slug: r, clientId: o }) {
    if (!e)
      throw new Error("schedulerAPIURL is required");
    if (!t)
      throw new Error("nylasSchedulerStore is required");
    if (!s && !n && !(r || o))
      throw new Error("sessionId is required for private configs. If using public config either pass a configurationId or a combination of slug and clientId.");
    e === "/" && (e = new URL(window.location.href).origin), this.configId = n, this.sessionId = s, this.schedulerAPIURL = e, this.nylasSchedulerStore = t, this.slug = r, this.clientId = o;
  }
  init() {
    O("NylasConnector init");
  }
  get schedulerStore() {
    return this.nylasSchedulerStore;
  }
  get scheduler() {
    return this._schedulerAPIConnector ? this._schedulerAPIConnector : (this._schedulerAPIConnector = new ge({
      schedulerAPIURL: this.schedulerAPIURL,
      schedulerStore: this.schedulerStore,
      sessionId: this.sessionId,
      configId: this.configId,
      slug: this.slug,
      clientId: this.clientId
    }), this._schedulerAPIConnector);
  }
  resetStores() {
    this.nylasSchedulerStore.reset();
  }
}
function fe(i = {}) {
  const e = {
    selectedDate: null,
    selectedLanguage: navigator.language,
    selectedTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    selectedTimeslot: null,
    showBookingForm: !1,
    availabilityOrderEmails: [],
    selectableDates: null,
    availability: [],
    eventDuration: 0,
    state: "ready",
    eventInfo: null,
    cancelledEventInfo: null,
    isLoading: !1,
    nylasBranding: !0,
    ...i
  };
  O("[defaultNylasStoreState]: ", e);
  const t = ie(e);
  return t.onChange("availability", (s) => {
    O("[availability]: ", s);
    const n = s.map((l) => l.start_time);
    O("[selectableDates]: ", n), t.set("selectableDates", n);
    const r = s[0];
    if (!r)
      return;
    const o = Math.floor((r.end_time.getTime() - r.start_time.getTime()) / 6e4);
    O("[durationMinutes]: ", o), t.set("eventDuration", o);
  }), t.reset = () => {
    for (const s in e) {
      const n = e[s];
      t.set(s, n);
    }
  }, t;
}
const A = (i, e) => {
  const t = i.isLoading, s = i.showNotification, n = i.nylasBranding;
  return a(
    ne,
    null,
    s && a("nylas-notification", null),
    t && a(
      "div",
      { class: "loading" },
      a(
        "div",
        { class: "left" },
        a("div", { class: "skeleton" })
      ),
      a(
        "div",
        { class: "right" },
        a("div", { class: "skeleton" }),
        a("div", { class: "skeleton" }),
        a("div", { class: "skeleton" }),
        a("div", { class: "skeleton" }),
        a("div", { class: "skeleton" })
      )
    ),
    !t && e,
    a("div", { class: "footer" }, n && a(
      "a",
      { href: "https://scheduler.nylas.com?utm_source=powered-by-nylas-logoutm_medium=link&utm_campaign=get-scheduler&utm_id=get-scheduler", class: "powered-by-nylas", target: "_blank", rel: "noreferrer noopener" },
      "Powered by ",
      a("span", { class: "sr-only" }, "Nylas"),
      a("nylas-logo", { "aria-hidden": !0 })
    ))
  );
}, X = (i, e) => a("div", { class: "message-banner" }, e), me = ':host{display:flex;flex-direction:column;overflow:visible;border-radius:var(--nylas-border-radius-2x);width:fit-content;background:var(--nylas-base-0);position:relative;box-shadow:0px 4px 8px 2px rgba(0, 0, 0, 0.05), 0px 8px 16px -2px rgba(0, 0, 0, 0.1);--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-color-blue-100:#e0e6f9;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;--nylas-color-black:#000000;--nylas-color-grey-900:#2c2c2c;--nylas-color-grey-800:#4b4b4b;--nylas-color-grey-700:#6e6e6e;--nylas-color-grey-600:#8e8e8e;--nylas-color-grey-500:#b3b3b3;--nylas-color-grey-400:#cacaca;--nylas-color-grey-300:#e1e1e1;--nylas-color-grey-200:#eaeaea;--nylas-color-grey-100:#f5f5f5;--nylas-color-grey-50:#fbfcfe;--nylas-color-white:#ffffff;--nylas-color-red-900:#992222;--nylas-color-red-700:#cc4841;--nylas-color-red-500:#ff786a;--nylas-color-red-300:#ffa79e;--nylas-color-red-100:#ffc5bf;--nylas-color-red-50:#ffeae8;--nylas-color-blue-900:#213571;--nylas-color-blue-700:#314fa9;--nylas-color-blue-500:#4169e1;--nylas-color-blue-300:#bdccf9;--nylas-color-blue-100:#e0e6f9;--nylas-color-blue-50:#f6f8fd;--nylas-color-yellow-900:#7c6506;--nylas-color-yellow-700:#c29f09;--nylas-color-yellow-500:#f7c90b;--nylas-color-yellow-300:#f9de70;--nylas-color-yellow-100:#fceba9;--nylas-color-yellow-50:#fdf4ce;--nylas-color-green-900:#0e6b60;--nylas-color-green-700:#16a392;--nylas-color-green-500:#17c3b2;--nylas-color-green-300:#74dbd1;--nylas-color-green-100:#a2e7e0;--nylas-color-green-50:#d1f3f0;--nylas-color-purple-900:#643554;--nylas-color-purple-700:#954f7d;--nylas-color-purple-500:#c769a7;--nylas-color-purple-300:#dda5ca;--nylas-color-purple-100:#e0bdd6;--nylas-color-purple-50:#e9dde5;--nylas-color-sky-900:#20698f;--nylas-color-sky-700:#2b8fc2;--nylas-color-sky-500:#6dceff;--nylas-color-sky-300:#8fdaff;--nylas-color-sky-100:#b8e7ff;--nylas-color-sky-50:#d9f2ff;font-family:var(--nylas-font-family);font-optical-sizing:auto;font-style:normal;font-variation-settings:"slnt" 0}@media screen and (max-width: 768px){:host{width:auto;min-width:325px}}:root{font-family:inherit}.error{padding:8rem 12rem;color:var(--nylas-base-0);background-color:var(--nylas-error);margin:1.5rem;border-radius:var(--nylas-border-radius-2x)}.message-banner{text-align:right;color:var(--nylas-base-800);padding:1rem;border-bottom:1px solid var(--nylas-color-primary-200);margin:0}.loading{margin:1.5rem;display:flex;gap:1rem}.loading .skeleton{border-radius:var(--nylas-border-radius-2x);animation:pulsate 1.5s infinite}.loading .skeleton:nth-child(2){animation-delay:-100ms}.loading .skeleton:nth-child(3){animation-delay:-200ms}.loading .skeleton:nth-child(4){animation-delay:-300ms}.loading .skeleton:nth-child(5){animation-delay:-400ms}.loading .left .skeleton{height:100%;width:400px}.loading .right .skeleton{height:5rem;width:300px;margin-bottom:1rem}.loading .right .skeleton:last-child{margin-bottom:0}@keyframes pulsate{0%{background-color:var(--nylas-base-50)}50%{background-color:var(--nylas-base-100)}100%{background-color:var(--nylas-base-50)}}.select-date-page,.additional-data-page,.booked-event-page,.manual-confirmation-page,.cancelled-event-page,.cancel-flow-page{border-top-left-radius:var(--nylas-border-radius-2x);border-top-right-radius:var(--nylas-border-radius-2x)}.select-date-page,.additional-data-page{display:flex}@media screen and (max-width: 768px){.select-date-page,.additional-data-page{flex-direction:column}}.booked-event-page,.manual-confirmation-page{background-color:var(--nylas-base-50)}.cancelled-event-page,.manual-confirmation-page,.cancel-flow-page{padding:1rem;height:496px;display:flex;justify-content:center;align-items:center}.booked-event-page,.manual-confirmation-page,.cancelled-event-page,.cancel-flow-page{min-width:784px;background:var(--nylas-base-50)}@media screen and (max-width: 768px){.booked-event-page,.manual-confirmation-page,.cancelled-event-page,.cancel-flow-page{min-width:90%}}.left-panel{display:flex;flex-direction:column;min-width:424px;border-top-left-radius:inherit;background:var(--nylas-base-0);position:relative;padding:1rem 0 0 0;height:624px}@media screen and (max-width: 768px){.left-panel{border-top-right-radius:inherit;min-width:unset;height:auto}}@media screen and (max-width: 768px){.select-date-page .left-panel{height:624px}}.border{margin-left:-20px;margin-right:-20px;border-top-width:1px;height:0.5px;background-color:var(--nylas-base-200)}@media screen and (max-width: 768px){.border{display:none}}.right-panel{min-width:360px;width:360px;background-color:var(--nylas-base-50);height:624px;padding-top:16px;border-left:1px solid var(--nylas-base-200);border-top-right-radius:inherit}.right-panel.reschedule{border-top-right-radius:0px}@media screen and (max-width: 768px){.right-panel{border-top-right-radius:0px;width:inherit;min-width:unset;height:auto;border-left:none}}.right-panel h2{display:flex;margin:0;height:48px;gap:0.5rem;justify-content:center;align-items:center;width:auto;font-size:1.125rem;line-height:1.5rem;font-weight:500;text-align:center;color:var(--nylas-base-800)}.additional-data-page .left-panel{background-color:var(--nylas-base-50)}.additional-data-page .right-panel{background-color:var(--nylas-base-0)}nylas-selected-event-card{height:604px;padding:0 1rem}@media screen and (max-width: 768px){nylas-selected-event-card{height:250px}}.footer{display:flex;justify-content:flex-end;align-items:center;padding:16px;font-size:14px;font-weight:300;color:var(--nylas-base-500);border-top:1px solid var(--nylas-base-200);min-height:24px}.footer .powered-by-nylas{display:flex;align-items:center;text-decoration:none;color:var(--nylas-base-500)}.footer .powered-by-nylas:hover{color:var(--nylas-base-800)}.footer svg{fill:var(--nylas-base-500)}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border-width:0}.footer svg{margin-top:1px}nylas-selected-event-card::part(nsec__timezone){position:absolute;bottom:0}nylas-notification{margin:1.5rem;width:-webkit-fill-available;width:-moz-available;position:absolute}nylas-locale-switch{position:absolute;padding:18px 20px;bottom:0;width:-webkit-fill-available;width:-moz-available;border-top:1px solid var(--nylas-base-200)}@media screen and (max-width: 768px){nylas-locale-switch{height:auto}}nylas-date-picker{padding:0 20px}button-component#report-issue{width:auto;position:absolute;bottom:4px;left:16px}nylas-feedback-form{position:absolute;top:0;height:100%;width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;background:rgba(0, 0, 0, 0.6);z-index:2;border-radius:inherit}', pe = me, Z = { title: c.t("genericErrorTitle"), type: j.Error, category: z.Component }, be = class {
  constructor(i) {
    V(this, i), this.init = F(this, "init", 7), this.schedulerWillLoad = F(this, "schedulerWillLoad", 7), this.schedulerDidLoad = F(this, "schedulerDidLoad", 7), this.nylasSchedulerError = F(this, "nylasSchedulerError", 7), this.nylasSchedulerInfo = F(this, "nylasSchedulerInfo", 7), this.configSettingsLoaded = F(this, "configSettingsLoaded", 7), this.bookingRefExtracted = F(this, "bookingRefExtracted", 7), this.bookedEventInfo = F(this, "bookedEventInfo", 7), this.mode = "app", this.defaultSchedulerState = void 0, this.sessionId = void 0, this.schedulerApiUrl = "https://api.us.nylas.com", this.bookingInfo = void 0, this.rescheduleBookingRef = void 0, this.cancelBookingRef = void 0, this.organizerConfirmationBookingRef = void 0, this.configurationId = void 0, this.slug = void 0, this.clientId = void 0, this.nylasBranding = !0, this.eventOverrides = {}, this.isLoading = void 0, this.themeConfig = void 0, this.localization = void 0, this.showNotification = !0, this.enableUserFeedback = !0, this.hour12 = void 0, this.automaticComponentRegistration = !0, this.selectedDateLabel = (/* @__PURE__ */ new Date()).toLocaleDateString(navigator.language, { dateStyle: "full" }) || `${c.t("noDateSelected")}`, this.refConfigId = void 0, this.language = navigator.language, this.showFeedbackModal = !1, this.bookingInfoConfirmed = null;
  }
  connectedCallback() {
    O("[nylas-scheduler] connectedCallback");
  }
  async componentWillLoad() {
    var n, r;
    O("[nylas-scheduler] Component will load"), this.enableUserFeedback && !re() && ae({
      dsn: "https://9d5731f1c77ca84c9ed3fb9b3ccf7ee1@o74852.ingest.us.sentry.io/4507889638178816",
      release: "1.4.5",
      integrations: (o) => [
        ...o.filter((l) => !1),
        ce({
          colorScheme: "system",
          autoInject: !1
        })
      ],
      autoSessionTracking: !1,
      beforeSend: () => null
    });
    const i = this.schedulerWillLoad.emit(this.host);
    if ("schedulerWillLoad" in this.eventOverrides && (await this.eventOverrides.schedulerWillLoad(i, this.nylasSchedulerConnector), i.defaultPrevented))
      return;
    this.stores = {
      scheduler: fe({
        bookingInfo: this.bookingInfo,
        nylasBranding: this.nylasBranding,
        themeConfig: this.themeConfig,
        hour12: this.hour12,
        ...this.defaultSchedulerState
      })
    }, this.baseProvider = new se(this.host, this.stores, this.automaticComponentRegistration, this.eventOverrides), this.refConfigId = this.configurationId;
    let e;
    if (this.rescheduleBookingRef) {
      const [o, l, d] = U(this.rescheduleBookingRef);
      this.refConfigId = o, this.stores.scheduler.set("rescheduleBookingId", l), e = this.bookingRefExtracted.emit({ configurationId: o, bookingId: l });
    } else if (this.cancelBookingRef) {
      const [o, l, d] = U(this.cancelBookingRef);
      this.refConfigId = o, this.stores.scheduler.set("cancelBookingId", l), e = this.bookingRefExtracted.emit({ configurationId: o, bookingId: l });
    } else if (this.organizerConfirmationBookingRef) {
      const [o, l, d] = U(this.organizerConfirmationBookingRef);
      this.refConfigId = o, this.stores.scheduler.set("organizerConfirmationBookingId", l), this.stores.scheduler.set("organizerConfirmationSalt", d), e = this.bookingRefExtracted.emit({ configurationId: o, bookingId: l, salt: d });
    }
    if ("bookingRefExtracted" in this.eventOverrides && (await this.eventOverrides.bookingRefExtracted(e, this.nylasSchedulerConnector), e.defaultPrevented) || !this.checkIfSessionIdOrConfigIdExists())
      return;
    const t = (n = this.baseProvider) == null ? void 0 : n.getStore("scheduler");
    this.nylasSchedulerConnector = new ue({
      schedulerAPIURL: this.schedulerApiUrl,
      sessionId: this.sessionId,
      configId: this.refConfigId,
      slug: this.slug,
      clientId: this.clientId,
      nylasSchedulerStore: t
    });
    const s = this.init.emit(this.host);
    "init" in this.eventOverrides && (await this.eventOverrides.init(s, this.nylasSchedulerConnector), s.defaultPrevented) || ((r = this.baseProvider) == null || r.componentWillLoad(this.nylasSchedulerConnector), this.applyThemeConfig(this.themeConfig));
  }
  async componentDidLoad() {
    var d, f, h, u, g, p, b, S;
    (d = this.baseProvider) == null || d.componentDidLoad();
    const i = this.schedulerDidLoad.emit(this.host);
    if ("schedulerDidLoad" in this.eventOverrides && (await this.eventOverrides.schedulerDidLoad(i, this.nylasSchedulerConnector), i.defaultPrevented) || !this.checkIfSessionIdOrConfigIdExists())
      return;
    this.localizationChanged(this.localization);
    const e = await ((f = this.nylasSchedulerConnector) == null ? void 0 : f.scheduler.getUISettings());
    if (!e || "error" in e) {
      this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(e == null ? void 0 : e.error) }, host: this.host });
      return;
    } else {
      "data" in e && ((h = e.data) != null && h.appearance) && console.info("Appearance settings have been returned from the configuration used byt his scheduling page; please remember to grab them from the configSettingsLoaded event and apply them as desired.");
      const m = this.configSettingsLoaded.emit({ settings: e });
      if ("configSettingsLoaded" in this.eventOverrides && (await this.eventOverrides.configSettingsLoaded(m, this.nylasSchedulerConnector), m.defaultPrevented))
        return;
    }
    const t = (u = this.baseProvider) == null ? void 0 : u.getStore("scheduler"), s = (p = (g = t == null ? void 0 : t.get("configSettings")) == null ? void 0 : g.scheduler) == null ? void 0 : p.available_days_in_future, n = t == null ? void 0 : t.get("selectedTimeslot");
    if (n && (n != null && n.start_time)) {
      if (!this.isTimeslotValid(n))
        return;
      if (t != null && t.get("showBookingForm")) {
        t == null || t.set("selectedDate", n.start_time);
        return;
      }
    }
    const r = t == null ? void 0 : t.get("selectedDate"), o = t == null ? void 0 : t.get("availability");
    let l;
    if (!(o && o.length > 0)) {
      if (r) {
        const { startTime: m, endTime: k, endTimeForAvailableDaysInFuture: I } = this.validateAvailableDaysInFuture(r, s || 30);
        r.getTime() < I * 1e3 && (l = await ((S = this.nylasSchedulerConnector) == null ? void 0 : S.scheduler.getAvailability(m, k)));
      } else {
        const m = /* @__PURE__ */ new Date(), { startTime: k, endTime: I, endTimeForAvailableDaysInFuture: x } = this.validateAvailableDaysInFuture(m, s || 30);
        m.getTime() < x * 1e3 && (l = await ((b = this.nylasSchedulerConnector) == null ? void 0 : b.scheduler.getAvailability(k, I)));
      }
      if ((!l || "error" in l) && this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(l == null ? void 0 : l.error) }, host: this.host }), !r) {
        let m = /* @__PURE__ */ new Date();
        const k = t == null ? void 0 : t.get("availability").find((I) => new Date(I.start_time) > /* @__PURE__ */ new Date());
        k && (m = k.start_time), t == null || t.set("selectedDate", m);
      }
    }
  }
  componentDisconnected() {
    var i;
    (i = this.baseProvider) == null || i.componentDisconnected();
  }
  bookingInfoChanged(i) {
    var e;
    (e = this.stores) == null || e.scheduler.set("bookingInfo", i);
  }
  rescheduleBookingRefChanged(i) {
    var e, t;
    if (i) {
      const [s, n] = U(i);
      (e = this.stores) == null || e.scheduler.set("rescheduleBookingId", n), this.refConfigId = s, (t = this.nylasSchedulerConnector) == null || t.scheduler.setConfigId(s);
    }
  }
  cancelBookingRefChanged(i) {
    var e, t;
    if (i) {
      const [s, n] = U(i);
      (e = this.stores) == null || e.scheduler.set("cancelBookingId", n), this.refConfigId = s, (t = this.nylasSchedulerConnector) == null || t.scheduler.setConfigId(s);
    }
  }
  organizerConfirmationBookingRefChanged(i) {
    var e, t;
    if (i) {
      const [s, n] = U(i);
      (e = this.stores) == null || e.scheduler.set("organizerConfirmationBookingId", n), this.refConfigId = s, (t = this.nylasSchedulerConnector) == null || t.scheduler.setConfigId(s);
    }
  }
  localizationChanged(i) {
    i && Object.keys(i).forEach((e) => {
      e in oe && c.addResourceBundle(e, "translation", i[e], !1, !0);
    });
  }
  themeConfigChanged(i) {
    var e, t;
    (t = (e = this.baseProvider) == null ? void 0 : e.getStore("scheduler")) == null || t.set("themeConfig", i), this.applyThemeConfig(i);
  }
  languageChanged(i) {
    const e = i.detail;
    this.language = e, c.changeLanguage(e);
  }
  async registerComponentHandler(i) {
    var e;
    (e = this.baseProvider) == null || e.registerComponent(i.detail);
  }
  async unregisterComponentHandler(i) {
    var e;
    (e = this.baseProvider) == null || e.unregisterComponent(i.detail);
  }
  async monthChangedHandler(i) {
    var o, l, d, f, h, u, g;
    const e = i.detail, t = (f = (d = (l = (o = this.nylasSchedulerConnector) == null ? void 0 : o.schedulerStore) == null ? void 0 : l.get("configSettings")) == null ? void 0 : d.scheduler) == null ? void 0 : f.available_days_in_future, { startTime: s, endTime: n, endTimeForAvailableDaysInFuture: r } = this.validateAvailableDaysInFuture(e, t || 30);
    if (!i.defaultPrevented && s < r && e.getTime() < r * 1e3) {
      const p = await ((h = this.nylasSchedulerConnector) == null ? void 0 : h.scheduler.getAvailability(s, n));
      (!p || "error" in p) && this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(p == null ? void 0 : p.error) }, host: this.host });
      const b = (u = this.stores) == null ? void 0 : u.scheduler.get("selectableDates");
      b && b.length > 0 && ((g = this.stores) == null || g.scheduler.set("selectedDate", b[0]));
    }
  }
  mapToBookingData(i) {
    var o, l, d;
    const e = (o = this.stores) == null ? void 0 : o.scheduler.get("selectedTimeslot"), t = (l = this.stores) == null ? void 0 : l.scheduler.get("selectedLanguage"), s = (d = this.stores) == null ? void 0 : d.scheduler.get("selectedTimezone"), n = e != null && e.start_time ? new Date(e == null ? void 0 : e.start_time).getTime() / 1e3 : "", r = e != null && e.end_time ? new Date(e == null ? void 0 : e.end_time).getTime() / 1e3 : "";
    return {
      additional_guests: i.guests,
      guest: { ...i.primaryParticipant },
      additional_fields: { ...i.additionalFields },
      start_time: n,
      end_time: r,
      email_language: t,
      timezone: s
    };
  }
  async bookButtonClickedHandler(i) {
    var d, f, h, u;
    if (i.defaultPrevented)
      return;
    const e = i.detail, t = this.mapToBookingData(e);
    this.bookingInfoConfirmed = e;
    const n = (f = (d = this.nylasSchedulerConnector) == null ? void 0 : d.schedulerStore) == null ? void 0 : f.get("rescheduleBookingId");
    if (n) {
      const g = await ((h = this.nylasSchedulerConnector) == null ? void 0 : h.scheduler.rescheduleBooking(n, e));
      (!g || "error" in g) && this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(g == null ? void 0 : g.error) }, host: this.host });
      const p = g == null ? void 0 : g.data, b = this.bookedEventInfo.emit({ ...g, data: { ...p, ...t } });
      this.bookingInfoConfirmed = { ...this.bookingInfoConfirmed, ...p }, "bookedEventInfo" in this.eventOverrides && await this.eventOverrides.bookedEventInfo(b, this.nylasSchedulerConnector);
      return;
    }
    const r = await ((u = this.nylasSchedulerConnector) == null ? void 0 : u.scheduler.bookTimeslot(e));
    (!r || "error" in r) && this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(r == null ? void 0 : r.error) }, host: this.host });
    const o = r == null ? void 0 : r.data, l = this.bookedEventInfo.emit({ ...r, data: { ...o, ...t } });
    this.bookingInfoConfirmed = { ...this.bookingInfoConfirmed, ...o }, "bookedEventInfo" in this.eventOverrides && await this.eventOverrides.bookedEventInfo(l, this.nylasSchedulerConnector);
  }
  dateSelectedHandler(i) {
    const e = i.detail;
    this.selectedDateLabel = e ? e.toLocaleDateString(this.language, { dateStyle: "full" }) : `${c.t("noDateSelected")}`;
  }
  cancelBookedEventErrorHandler(i) {
    this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(i.detail.error) }, host: this.host });
  }
  cancelBookedEventValidationErrorHandler(i) {
    this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(i.detail.error) }, host: this.host });
  }
  rescheduleBookedEventErrorHandler(i) {
    this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(i.detail.error) }, host: this.host });
  }
  confirmBookingErrorHandler(i) {
    this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject(i.detail.error) }, host: this.host });
  }
  feedbackModalClosedHandler() {
    this.showFeedbackModal = !1;
  }
  eventIsFullHandler(i) {
    const e = i.detail.error;
    i.detail.type === "error" ? this.nylasSchedulerError.emit({ notification: { ...this.getErrorObject({ message: e }) }, host: this.host }) : this.nylasSchedulerInfo.emit({
      notification: {
        title: "Event is full",
        category: z.Component,
        type: j.Info,
        description: "The event you selected is full. Please try a different time.",
        id: (/* @__PURE__ */ new Date()).getTime().toString(),
        ttl: 3e3
      },
      host: this.host
    });
  }
  feedbackSubmittedHandler(i) {
    const t = {
      eventId: le("Scheduling Page User Feedback", {
        extra: {
          configId: this.configurationId,
          slug: this.slug
        }
      }),
      message: i.detail.feedback
    };
    de(t, {
      includeReplay: !0,
      captureContext: {
        tags: {
          "nylas-web-element": "nylas-scheduling",
          "nylas-web-element-version": "1.4.5",
          "nylas-config-id": this.configurationId,
          "nylas-slug": this.slug,
          "host-url": window.location.href
        },
        extra: {
          configId: this.configurationId,
          slug: this.slug
        }
      }
    }), this.showFeedbackModal = !1;
  }
  async getNylasSchedulerStore() {
    var i;
    return (i = this.baseProvider) == null ? void 0 : i.getStore("scheduler");
  }
  async getNylasSchedulerConnector() {
    return this.nylasSchedulerConnector;
  }
  async getRef() {
    return this.host;
  }
  getErrorObject(i) {
    return {
      title: (i == null ? void 0 : i.title) || Z.title,
      category: (i == null ? void 0 : i.category) || Z.category,
      type: j.Error,
      description: (i == null ? void 0 : i.message) || "",
      id: (/* @__PURE__ */ new Date()).getTime().toString(),
      ttl: "none"
    };
  }
  checkIfSessionIdOrConfigIdExists() {
    if (!this.sessionId && !this.refConfigId && !(this.slug && this.clientId)) {
      let i = "";
      return this.sessionId || (i += c.t("sessionIdRequiredErrorMessage")), !this.sessionId && !this.refConfigId && !(this.slug && this.clientId) && (i = c.t("sessionIdRequiredErrorMessage") + " " + c.t("publicConfigErrorMessage")), this.nylasSchedulerError.emit({
        notification: {
          title: c.t("schedulingComponentErrorTitle"),
          category: z.Component,
          type: j.Error,
          description: i,
          id: (/* @__PURE__ */ new Date()).getTime().toString(),
          ttl: "none"
        },
        host: this.host
      }), !1;
    }
    return !0;
  }
  isTimeslotValid(i) {
    return new Date(i.start_time) < /* @__PURE__ */ new Date() ? (this.nylasSchedulerError.emit({
      notification: {
        title: c.t("invalidTimeslotErrorTitle"),
        category: z.Component,
        type: j.Error,
        description: c.t("invalidTimeslotErrorMessage"),
        id: (/* @__PURE__ */ new Date()).getTime().toString(),
        ttl: "none"
      },
      host: this.host
    }), !1) : !0;
  }
  validateAvailableDaysInFuture(i, e) {
    const t = /* @__PURE__ */ new Date(), s = new Date(i.getFullYear(), i.getMonth(), 1).getTime() / 1e3, n = new Date(i.getFullYear(), i.getMonth() + 1, 1).getTime() / 1e3, r = Math.floor(K(t, e).getTime() / 1e3), o = Math.min(r, n);
    return { startTime: s < t.getTime() / 1e3 ? Math.floor(t.getTime() / 1e3) : s, endTime: o, endTimeForAvailableDaysInFuture: r };
  }
  applyThemeConfig(i) {
    if (i)
      for (const [e, t] of Object.entries(i))
        this.host.style.setProperty(`${e}`, t);
  }
  onFeedbackClick(i) {
    i.preventDefault(), this.showFeedbackModal = !0;
  }
  redirectToCustomUrl(i) {
    window.location.assign(i);
  }
  render() {
    var b, S, m, k, I, x, w, L, y, B, D, M;
    const i = this.mode === "app", e = (b = this.baseProvider) == null ? void 0 : b.getStore("scheduler"), t = e == null ? void 0 : e.get("eventInfo"), s = e == null ? void 0 : e.get("showBookingForm"), n = e == null ? void 0 : e.get("cancelledEventInfo"), r = e == null ? void 0 : e.get("cancelBookingId"), o = e == null ? void 0 : e.get("selectedTimeslot"), l = e == null ? void 0 : e.get("rescheduleBookingId"), d = e == null ? void 0 : e.get("organizerConfirmationBookingId"), f = e == null ? void 0 : e.get("rejectBookingId"), h = e == null ? void 0 : e.get("confirmedEventInfo"), u = (e == null ? void 0 : e.get("nylasBranding")) || this.nylasBranding, g = e == null ? void 0 : e.get("selectedDate"), p = (m = (S = e == null ? void 0 : e.get("configSettings")) == null ? void 0 : S.scheduler) == null ? void 0 : m.confirmation_redirect_url;
    if (this.selectedDateLabel = g && this.language ? ee(g.toLocaleDateString(this.language, { dateStyle: "full" })) : `${c.t("noDateSelected")}`, i && (r || f) && !n)
      return a(P, null, a(A, { nylasBranding: u, isLoading: this.isLoading, showNotification: this.showNotification }, a("div", { class: "cancel-flow-page", part: "cancel-flow-page" }, a("nylas-cancel-booking-form", { selectedTimeslot: o, cancelBookingId: r, rejectBookingId: f, exportparts: "ncbf, ncbf__icon, ncbf__title, ncbf__description, ncbf__reason-textarea, ncbf__button-cta, ncbf__button-outline, ncbf__card" }))), this.enableUserFeedback && a("button-component", { id: "report-issue", variant: "basic", onClick: (_) => this.onFeedbackClick(_) }, a("feedback-icon", null)), this.showFeedbackModal && a("nylas-feedback-form", null));
    if (i && d)
      return a(P, null, a(A, null, a("div", { class: "manual-confirmation-page", part: "manual-confirmation-page" }, a("nylas-organizer-confirmation-card", { organizerConfirmationBookingId: d, exportparts: "nmcc, nmcc__title, nmcc__description, nmcc__button-cta, nmcc__button-outline" }))), this.enableUserFeedback && a("button-component", { id: "report-issue", variant: "basic", onClick: (_) => this.onFeedbackClick(_) }, a("feedback-icon", null)), this.showFeedbackModal && a("nylas-feedback-form", null));
    if (i && n)
      return a(P, null, a(A, { nylasBranding: u, isLoading: this.isLoading, showNotification: this.showNotification }, a("div", { class: "cancelled-event-page", part: "cancelled-event-page" }, a("nylas-cancelled-event-card", { cancelledEventInfo: n, exportparts: "ncec, ncec__icon, ncec__title, ncec__description, ncec__button-outline, ncec__card" }))), this.enableUserFeedback && a("button-component", { id: "report-issue", variant: "basic", onClick: (_) => this.onFeedbackClick(_) }, a("feedback-icon", null)), this.showFeedbackModal && a("nylas-feedback-form", null));
    if (i && h)
      return a(P, null, a(A, { nylasBranding: u, isLoading: this.isLoading, showNotification: this.showNotification }, a("div", { class: "cancelled-event-page", part: "confirmed-event-page" }, a("nylas-confirmed-event-card", { confirmedEventInfo: h, exportparts: "ncec, ncec__icon, ncec__title, ncec__description, ncec__button-outline, ncec__card" }))), this.enableUserFeedback && a("button-component", { id: "report-issue", variant: "basic", onClick: (_) => this.onFeedbackClick(_) }, a("feedback-icon", null)), this.showFeedbackModal && a("nylas-feedback-form", null));
    if (i && t && p) {
      const _ = (k = this.bookingInfoConfirmed) == null ? void 0 : k.primaryParticipant, C = (I = this.bookingInfoConfirmed) == null ? void 0 : I.location, N = (x = this.bookingInfoConfirmed) == null ? void 0 : x.booking_ref, R = ((w = this.bookingInfoConfirmed) == null ? void 0 : w.additionalFields) || {};
      if (this.bookingInfo && typeof ((L = this.bookingInfo) == null ? void 0 : L.additionalFields) < "u") {
        const $ = this.bookingInfo.additionalFields;
        Object.keys($).forEach((W) => {
          !R[W] && ($ != null && $[W]) && (R[W] = $[W].value);
        });
      }
      const v = (y = this.stores) == null ? void 0 : y.scheduler.get("selectedTimeslot"), E = (B = this.stores) == null ? void 0 : B.scheduler.get("selectedTimezone"), H = (D = this.stores) == null ? void 0 : D.scheduler.get("selectedLanguage"), q = (M = this.stores) == null ? void 0 : M.scheduler.get("configSettings"), G = this.configurationId ? this.configurationId : q == null ? void 0 : q.configuration_id, Q = window.location.search, T = new URLSearchParams(Q);
      T.set("booking_id", t.booking_id), _ != null && _.name && T.set("name", _.name), _ != null && _.email && T.set("email", _.email), v != null && v.start_time && T.set("start_time", (new Date(v.start_time).getTime() / 1e3).toString()), v != null && v.end_time && T.set("end_time", (new Date(v.end_time).getTime() / 1e3).toString()), E && T.set("tz", E), H && T.set("language", H), R && T.set("additional_values", JSON.stringify(R)), this.slug && T.set("page_slug", this.slug), G && T.set("config_id", G), C && T.set("location", C), N && T.set("booking_ref", N), this.redirectToCustomUrl(`${p}?${T.toString()}`);
      return;
    }
    if (i && t)
      return a(P, null, a(A, { nylasBranding: u, isLoading: this.isLoading, showNotification: this.showNotification }, a("div", { class: "booked-event-page", part: "booked-event-page ns_booked-event-page" }, a("nylas-booked-event-card", { selectedTimeslot: o, eventInfo: t, exportparts: "nbec, nbec__title, nbec__card, nbec__description, nbec__button-outline, nbec__cancel-cta, nbec__reschedule-cta" }))), this.enableUserFeedback && a("button-component", { id: "report-issue", variant: "basic", onClick: (_) => this.onFeedbackClick(_) }, a("feedback-icon", null)), this.showFeedbackModal && a("nylas-feedback-form", null));
    if (i && (!t || l) && !s) {
      const _ = this.host.querySelector('[slot="timeslot-picker-cta-label"]');
      return a(P, null, a(A, { nylasBranding: u, isLoading: this.isLoading, showNotification: this.showNotification }, l && a(X, null, `${c.t("rescheduleTitle")}`), a("div", { class: "select-date-page", part: "select-date-page ns_select-date-page" }, a("div", { class: "left-panel", part: "ns_left-panel" }, a("nylas-date-picker", { exportparts: "ndp, ndp__title, ndp__month-header, ndp__month-button, ndp__day, ndp__date, ndp__date--disabled, ndp__date--selected, ndp__date--current-day, ndp__date--current-month" }), a("nylas-locale-switch", { exportparts: "nls, nls__timezone, nls__timezone-dropdown, nls__timezone-drop-button, nls__timezone-drop-button-selected-label, nls__timezone-drop-content, nls__timezone-drop-label, nls__language, nls__language-dropdown, nls__language-drop-button, nls__language-drop-content, nls__language-drop-label" })), a("div", { class: `right-panel ${l ? "reschedule" : ""}`, part: `ns_right-panel ${l ? "ns_reschedule" : ""}` }, a("h2", { part: "ns_right-panel__title" }, a("calendar-icon", { part: "ns_right-panel__calendar-icon" }), a("span", { id: "selectedDate", part: "ns_right-panel__selected-date" }, this.selectedDateLabel)), a("nylas-timeslot-picker", { exportparts: "ntp, ntp__time-picker-wrapper, ntp__timeslots, ntp__timeslot, ntp__timeslot--selected, ntp__button-primary" }, _ && a("span", { slot: "timeslot-picker-cta-label" }, a("slot", { name: "timeslot-picker-cta-label" })))))), this.enableUserFeedback && a("button-component", { id: "report-issue", variant: "basic", onClick: (C) => this.onFeedbackClick(C) }, a("feedback-icon", null)), this.showFeedbackModal && a("nylas-feedback-form", null));
    }
    return i && !t && s ? a(P, null, a(A, { nylasBranding: u, isLoading: this.isLoading, showNotification: this.showNotification }, l && a(X, null, `${c.t("rescheduleTitle")}`), a("div", { class: "additional-data-page", part: "additional-data-page ns_additional-data-page" }, a("div", { class: "left-panel ns_left-panel", part: "ns_left-panel" }, a("div", { class: "wrapper", part: "ns_left-panel__wrapper" }, a("nylas-selected-event-card", { exportparts: "nsec, nsec__card, nsec__icon, nsec__date, nsec__time, nsec__timezone" }))), a("div", { class: `right-panel ${l ? "reschedule" : ""}`, part: `ns_right-panel ${l ? "ns_reschedule" : ""}` }, a("nylas-booking-form", { exportparts: "nbf, nbf__input-textfield, nbf__button-ghost, nbf__button-outline, nbf__button-primary, nbf__input-wrapper, nbf__checkbox-component, nbf__radio-button-group, nbf__textarea-component, nbf__dropdown, nbf__dropdown-button, nbf__dropdown-content" })))), this.enableUserFeedback && a("button-component", { id: "report-issue", variant: "basic", onClick: (_) => this.onFeedbackClick(_) }, a("feedback-icon", null)), this.showFeedbackModal && a("nylas-feedback-form", null)) : a(P, null, a("slot", null));
  }
  get host() {
    return te(this);
  }
  static get watchers() {
    return {
      bookingInfo: ["bookingInfoChanged"],
      rescheduleBookingRef: ["rescheduleBookingRefChanged"],
      cancelBookingRef: ["cancelBookingRefChanged"],
      organizerConfirmationBookingRef: ["organizerConfirmationBookingRefChanged"],
      localization: ["localizationChanged"],
      themeConfig: ["themeConfigChanged"]
    };
  }
};
be.style = pe;
export {
  be as nylas_scheduling
};
